import React from 'react';

export const BodyEyeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.84743 40.143C12.5374 27.9676 26.1286 12.5 49.9967 12.5C75.2016 12.5 89.1322 30.4543 94.8803 42.5339C97.0556 47.1052 97.6282 52.504 95.7061 57.4841C90.5585 70.8209 75.3148 87.5 49.9967 87.5C26.3388 87.5 11.7543 72.2963 5.30972 60.0019C1.97388 53.638 2.52167 46.1957 5.84743 40.143ZM8.58622 41.6479C14.9974 29.9799 27.7371 15.625 49.9967 15.625C73.461 15.625 86.5501 32.3009 92.0585 43.8766C93.9263 47.8019 94.3559 52.3034 92.7907 56.3589C88.0101 68.7448 73.7706 84.375 49.9967 84.375C27.8634 84.375 14.1747 70.1826 8.07751 58.551C5.291 53.2352 5.69592 46.908 8.58622 41.6479Z"
        fill="#9B9B9B"
      />
      <path
        d="M49.9963 15.625C27.7367 15.625 14.9971 29.9799 8.58586 41.6479C5.69556 46.908 5.29064 53.2352 8.07716 58.551C14.1743 70.1826 27.863 84.375 49.9963 84.375C73.7702 84.375 88.0097 68.7448 92.7903 56.3589C94.3556 52.3034 93.926 47.8019 92.0581 43.8766C86.5498 32.3009 73.4607 15.625 49.9963 15.625Z"
        fill="white"
      />
      <path
        d="M26.7867 21.012C24.7264 21.6462 22.4263 22.0006 20 22.0006C11.8964 22.0006 5.19988 18.0472 4.14472 12.9189C3.95831 13.2183 3.78484 13.5159 3.62378 13.8091C2.83823 15.2387 2.75437 16.9065 3.47027 18.2722C5.31016 21.7822 9.40393 26.0002 15.9987 26.0002C21.0254 26.0002 24.6149 23.6702 26.7867 21.012Z"
        fill="#E6E6E6"
      />
      <circle cx="50" cy="50" r="25" fill="#7D4533" />
      <circle cx="50" cy="50" r="12.5" fill="#1C1C1C" />
      <circle cx="42.9688" cy="40.625" r="5.46875" fill="white" />
    </svg>
  );
};
